import React from 'react';
import SystemAuctionLotsManager from '../../features/admin/SystemAuctionLotsManager';

const SystemAuctionLotsManagerPage = () => {
  return (
    <div className="h-full">
      <SystemAuctionLotsManager />
    </div>
  );
};

export default SystemAuctionLotsManagerPage;
